<!-- Sit outside @if so `@ViewChild('skinEditorTemplate', { static: true })`
     can resolve it at construction time. ng-template renders nothing on its
     own; visibility is gated by the watermark's @if blocks below. -->
<ng-template #skinEditorTemplate>
  <div class="sg-skin-editor">
    <label class="sg-skin-editor__field">
      <span class="sg-skin-editor__label">Base data</span>
      <select class="sg-skin-editor__input" [value]="editingSkin.base" (change)="editingSkin.base = $any($event.target).value">
        <!-- `[selected]` per option, not just `[value]` on the <select>: the
             options are created by @for as children, so the select's value
             binding can be applied before they exist and the control falls back
             to the first option ("American") — which on Save would silently
             rewrite the skin's base. -->
        @for (opt of baseDataOptions; track opt.value) {
          <option [value]="opt.value" [selected]="opt.value === editingSkin.base">{{ opt.label }}</option>
        }
      </select>
    </label>
    <label class="sg-skin-editor__field">
      <span class="sg-skin-editor__label">Company name</span>
      <input
        type="text"
        class="sg-skin-editor__input"
        [value]="editingSkin.companyName"
        (input)="editingSkin.companyName = $any($event.target).value"
        placeholder="Midas Wealth" />
    </label>
    <label class="sg-skin-editor__field">
      <span class="sg-skin-editor__label">Lender type</span>
      <select class="sg-skin-editor__input" [value]="editingSkin.lenderType" (change)="editingSkin.lenderType = $any($event.target).value">
        <option value="super-lender">Super-lender</option>
        <option value="standard-lender">Standard lender</option>
      </select>
    </label>
    <div class="sg-skin-editor__row">
      <label class="sg-skin-editor__field">
        <span class="sg-skin-editor__label">User first name</span>
        <input
          type="text"
          class="sg-skin-editor__input"
          [value]="editingSkin.firstName"
          (input)="editingSkin.firstName = $any($event.target).value"
          placeholder="Ege" />
      </label>
      <label class="sg-skin-editor__field">
        <span class="sg-skin-editor__label">User last name</span>
        <input
          type="text"
          class="sg-skin-editor__input"
          [value]="editingSkin.lastName"
          (input)="editingSkin.lastName = $any($event.target).value"
          placeholder="(optional)" />
      </label>
    </div>
    <div class="sg-skin-editor__footer">
      <button type="button" class="sg-skin-editor__link" (click)="onResetSkinOverrides()">
        {{ editingSkinIsAdhoc ? "Delete this demo" : "Reset to code default" }}
      </button>
    </div>
  </div>
</ng-template>
@if (visible) {
  @if (demoMinimalMode) {
    <div class="sg-build-watermark sg-build-watermark--demo" role="contentinfo" aria-label="Demo build">
      <button
        type="button"
        class="sg-build-watermark__demo-pill sg-build-watermark__demo-pill--clickable"
        (click)="onEditDemoIdentity()"
        title="Open demo settings (Ctrl+Shift+I)"
        [attr.aria-label]="'Open demo settings — ' + demoLabel">
        <span class="sg-build-watermark__demo-prefix">DEMO</span>
        @if (demoCodeLabel || demoBaseLabel || demoLenderLabel) {
          <span class="sg-build-watermark__demo-config">
            <span class="sg-build-watermark__demo-bracket">[</span>
            @if (demoCodeLabel) {
              <span class="sg-build-watermark__demo-code">{{ demoCodeLabel }}</span>
            }
            @if (demoBaseLabel) {
              <span class="sg-build-watermark__demo-base">{{ demoBaseLabel }}</span>
            }
            @if (demoLenderLabel) {
              <span class="sg-build-watermark__demo-lender">{{ demoLenderLabel }}</span>
            }
            <span class="sg-build-watermark__demo-bracket">]</span>
          </span>
        }
      </button>
    </div>
  } @else {
    <div class="sg-build-watermark" role="contentinfo" aria-label="Build info">
      <span class="sg-build-watermark__pill">
        <span class="sg-build-watermark__field sg-build-watermark__field--env" [attr.data-env]="displayEnv">
          <span class="sg-build-watermark__key">ENV</span>
          @if (canEditEnv) {
            <button type="button" class="sg-build-watermark__menu-trigger" [matMenuTriggerFor]="apiEnvMenu.matMenu" aria-label="API environment">
              <span class="sg-build-watermark__val">{{ displayEnv }}</span>
              <span class="sg-build-watermark__caret" aria-hidden="true">▾</span>
            </button>
            <sg-menu #apiEnvMenu [groups]="apiEnvMenuGroups" (itemSelect)="onEnvMenuSelect($event)"></sg-menu>
          } @else {
            <span class="sg-build-watermark__val">{{ displayEnv }}</span>
          }
        </span>
        @for (flag of roleFlags; track flag.key) {
          <label class="sg-build-watermark__field sg-build-watermark__flag" [class.sg-build-watermark__flag--on]="isFlagOn(flag.key)">
            <input
              type="checkbox"
              class="sg-build-watermark__checkbox"
              [checked]="isFlagOn(flag.key)"
              (change)="onFlagToggle(flag.key, $event)"
              [attr.aria-label]="flag.label" />
            <span class="sg-build-watermark__key">{{ flag.label }}</span>
          </label>
        }
        @if (env.meta?.branch) {
          <span class="sg-build-watermark__field sg-build-watermark__field--accent">
            <span class="sg-build-watermark__key">BRANCH</span>
            <span class="sg-build-watermark__val">{{ env.meta?.branch }}</span>
          </span>
        }
        @if (hash) {
          <span class="sg-build-watermark__field">
            <span class="sg-build-watermark__key">HASH</span>
            <span class="sg-build-watermark__val">{{ hash }}</span>
          </span>
        }
        @if (id) {
          <span class="sg-build-watermark__field">
            <span class="sg-build-watermark__key">ID</span>
            <span class="sg-build-watermark__val">{{ id }}</span>
          </span>
        }
        @if (version) {
          <span class="sg-build-watermark__field">
            <span class="sg-build-watermark__key">VERSION</span>
            <span class="sg-build-watermark__val">{{ version }}</span>
          </span>
        }
      </span>
    </div>
  }
}
